import { useCallback } from 'react'
import type { MutationHook } from '@commerce/utils/types'
import useUpdateDiscount, { UseUpdateDiscount } from '../../commerce/actual-cart/use-update-discount'
import useCart from './use-cart'

import {
  cartCreate,
  cartDiscountUpdateMutation,
  cartToCart,
  getCartId,
} from '../utils'
import { AttributeInput, Maybe, Mutation, Scalars} from '../schema'

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationCartDiscountUpdateArgs = {
  discountCodes: Array<Scalars['String']>,
  cartId: Scalars['ID']
}

export default useUpdateDiscount as UseUpdateDiscount<typeof handler>

export const handler: MutationHook<any> = {
  fetchOptions: {
    query: cartDiscountUpdateMutation,
  },
  async fetcher({ input: { discountCode }, options, fetch }) {
    let cartId;
    cartId = getCartId();
    if(!cartId){
      const cart = await cartCreate(fetch, true);
      cartId = cart?.id;
    }

    const { cartDiscountUpdate } = await fetch<
      Mutation,
      MutationCartDiscountUpdateArgs
    >({
      ...options,
      variables: {
        cartId: cartId,
        discountCodes: [discountCode]
      },
    }) as { cartDiscountUpdate: any }
    return cartToCart(cartDiscountUpdate)
  },
  useHook: ({ fetch }) => () => {
    const { mutate } = useCart()

    return useCallback(
      async function updateDiscount(input) {
        try {
          const data = await fetch({ input })
          await mutate(data, false)
          return data
        } catch (e) {
          return e
        }
      },
      [fetch, mutate]
    )
  },
}
